import * as React from 'react';

import TransactionForm from 'components/forms/TransactionForm';
import ContentWrapper from 'components/ContentWrapper';

const TransactionEditScreen = () => (
  <ContentWrapper>
    <TransactionForm editType />
  </ContentWrapper>
);

export default TransactionEditScreen;
